export const USER_QUERY_KEY = "checkAuth" as const;

export const USER_PERMISSIONS_QUERY_KEY = "userPermissions" as const;

export const USER_TIMEZONE_QUERY_KEY = "user-timezone-setting" as const;
